export default "__VITE_PUBLIC_ASSET__aa91ce20__"